/**
 * 全局配置
 *
 */

// 版本号
const VERSION = 'V1.0.0';
console.log(process.env);
//环境（    development |   production ）
const ENV = process.env.NODE_ENV;

//API接口地址
const API_ADDRESS = {
    development: '/api/',
    //production: 'https://wework.heefish.cn',
    production: "https://getreadycreators.wework.cn",
    test: 'https://wework.heefish.cn',
};

//API请求超时时间
const REQUEST_TIMEOUT = 30000;

// 业务启用状态
const ON = 1;

// 业务禁用状态
const OFF = 0;

// 验证码重发秒数
const AUTH_CODE_TIME = 60;

export default {
    VERSION,
    ENV,
    ON,
    OFF,
    API_ADDRESS,
    REQUEST_TIMEOUT,
    AUTH_CODE_TIME,
};